import React from 'react';
import { object } from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';
import { metric } from '@fiverr-private/perseus';
import { MP_CLICKED_CONTACT_ME } from '../../../../utils/mixPanelEvents';
import { BQ_CLICKED_CONTACT_SELLER } from '../../../../utils/bigQueryEvents';
import Trigger from '../../../shared/FirstMessagePopup/Trigger';
import './style.scss';

const ContactMe = (props, context) => {

    const reportContactMeClick = () => {
        const { biEvents } = context;

        biEvents.sendMixPanelEvent({
            eventName: MP_CLICKED_CONTACT_ME,
            params: { 'Source component': 'Gig page seller card' }
        });

        biEvents.sendBigQueryEvent({
            eventName: BQ_CLICKED_CONTACT_SELLER,
            params: { name: 'about_the_seller' }
        });

        metric.count('contact_me.click');
    };

    const shouldShowContact = () => {
        const { isOnVacation } = context.general;
        return !isOnVacation;
    };

    if (!shouldShowContact()) {
        return null;
    }

    return (
        <Trigger onClick={reportContactMeClick} className="btn-contact-me">
            <I18n k={'gig_page_perseus.seller_card.contact_me'}/>
        </Trigger>
    );
};

ContactMe.contextTypes = {
    biEvents: object,
    general: object
};

export default ContactMe;
